export default __webpack_public_path__ + "8a60fe3b274d5bc3ce50548825661fd4.svg";